import React from "react";

interface IGuide {
  children: React.ReactNode;
}
export default function GuideRightContent(props: IGuide) {
  const { children } = props;
  return <ul className="mt-30 rs-news-list">{children}</ul>;
}
